export const LUnidadeMedidaTempo = [
  { key: 0, text: "0 - Padrão/Inteiro" },
  { key: 1, text: "1 - Padrão/Fração Livre" },
  { key: 2, text: "2 - Padrão/Fração Múltipla" },
  { key: 3, text: "3 - Centimetros cúbicos" },
  { key: 4, text: "4 - Centimetros quadrados" },
  { key: 5, text: "5 - Tempo" },
];
